import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
var RequestManagerService = /** @class */ (function () {
    function RequestManagerService() {
        // ユーザーIDごとのリクエスト管理
        this.userRequests = new Map();
        // 現在のユーザーID（実際の実装では認証サービスから取得）
        this.currentUserId = 'default';
    }
    /**
     * ユーザーIDを設定
     */
    RequestManagerService.prototype.setCurrentUserId = function (userId) {
        this.currentUserId = userId;
    };
    /**
     * リクエストタイプごとのキャンセルSubjectを取得
     */
    RequestManagerService.prototype.getCancelSubject = function (requestType) {
        if (!this.userRequests.has(this.currentUserId)) {
            this.userRequests.set(this.currentUserId, new Map());
        }
        var userRequestMap = this.userRequests.get(this.currentUserId);
        if (!userRequestMap.has(requestType)) {
            userRequestMap.set(requestType, new Subject());
        }
        return userRequestMap.get(requestType);
    };
    /**
     * 特定のリクエストタイプの進行中のリクエストをキャンセル
     */
    RequestManagerService.prototype.cancelRequest = function (requestType) {
        var cancelSubject = this.getCancelSubject(requestType);
        cancelSubject.next();
    };
    /**
     * ユーザーの全リクエストをキャンセル
     */
    RequestManagerService.prototype.cancelAllUserRequests = function () {
        var userRequestMap = this.userRequests.get(this.currentUserId);
        if (userRequestMap) {
            userRequestMap.forEach(function (cancelSubject) {
                cancelSubject.next();
            });
        }
    };
    /**
     * 特定のリクエストタイプのObservableをキャンセル可能にする
     */
    RequestManagerService.prototype.makeCancellable = function (observable, requestType) {
        return observable.pipe(takeUntil(this.getCancelSubject(requestType)));
    };
    /**
     * ユーザーがログアウトした際のクリーンアップ
     */
    RequestManagerService.prototype.cleanupUser = function (userId) {
        var userRequestMap = this.userRequests.get(userId);
        if (userRequestMap) {
            userRequestMap.forEach(function (cancelSubject) {
                cancelSubject.next();
                cancelSubject.complete();
            });
            this.userRequests.delete(userId);
        }
    };
    /**
     * 全ユーザーのリクエストをクリーンアップ
     */
    RequestManagerService.prototype.cleanupAllUsers = function () {
        var _this = this;
        this.userRequests.forEach(function (userRequestMap, userId) {
            _this.cleanupUser(userId);
        });
    };
    RequestManagerService.ngInjectableDef = i0.defineInjectable({ factory: function RequestManagerService_Factory() { return new RequestManagerService(); }, token: RequestManagerService, providedIn: "root" });
    return RequestManagerService;
}());
export { RequestManagerService };
